// Only these base locales are translated in the marketing JSON
const baseLocales = [
  'da',
  'en',
  'fi',
  'fr',
  'nb',
  'sv',
]

// Regional variations of supported languages - exported separately from Crowdin
const regionalLocales = [
  'fr-ca',
  'pt-br',
  'es-us',
  'zh-tw',
]

const additionalLocales = [
  'ar',
  'bg',
  'cs',
  'cy',
  'de',
  'el',
  'es',
  'et',
  'hr',
  'hu',
  'id',
  'is',
  'it',
  'ja',
  'ko',
  'lt',
  'lv',
  'mk',
  'nl',
  'nn',
  'pl',
  'pt',
  'ro',
  'ru',
  'sk',
  'sl',
  'sq',
  'sr',
  'tr',
  'uk',
  'vi',
  'zh',
]

export const supportedLocales = [
  ...baseLocales,
  ...regionalLocales,
  ...additionalLocales,
]
